import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const FacilitiesTypes = ({ form, facilitiesTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Бытовая техника">
      {getFieldDecorator('facility_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите опции"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {facilitiesTypes &&
            facilitiesTypes.map(type => (
              <Option
                key={type.facilityKey}
                value={type.facilityKey}
                label={type.facilityName}
              >
                {type.facilityName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(FacilitiesTypes, ['facilitiesTypes']);
